export const getFormattedPrice = (price, currency) => `${currency} ${price.toFixed(2)}`
